import { render, staticRenderFns } from "./AIHelper.vue?vue&type=template&id=57af5a2b&scoped=true"
import script from "./AIHelper.vue?vue&type=script&lang=js"
export * from "./AIHelper.vue?vue&type=script&lang=js"
import style0 from "./AIHelper.vue?vue&type=style&index=0&id=57af5a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af5a2b",
  null
  
)

export default component.exports